import { useEffect, useState } from "react";
import { api, API } from "./api";

const DEFAULTS = {
  company_name: "BTP·STUDIO",
  company_tagline: "Bureau d'études — Génie Civil",
  company_logo_url: null,
};

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL || "";

function absolutize(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  // /api/settings/logo?v=N -> backend origin + path
  if (url.startsWith("/api/")) return BACKEND_ORIGIN + url;
  return url;
}

// Module-level cache so multiple components don't hit the API
let cached = null;
let inflight = null;
const listeners = new Set();

function notify(data) {
  cached = data;
  listeners.forEach((l) => l(data));
}

export async function refreshBranding() {
  try {
    const r = await api.get("/settings/public");
    notify({ ...DEFAULTS, ...r.data, company_logo_url: absolutize(r.data?.company_logo_url) });
  } catch {
    notify(DEFAULTS);
  }
}

export function useBranding() {
  const [data, setData] = useState(() => cached || DEFAULTS);

  useEffect(() => {
    listeners.add(setData);
    if (!cached) {
      if (!inflight) inflight = refreshBranding().finally(() => { inflight = null; });
    }
    return () => listeners.delete(setData);
  }, []);

  // Apply document.title dynamically
  useEffect(() => {
    if (data?.company_name) document.title = data.company_name;
  }, [data?.company_name]);

  return data;
}
